import "core-js/modules/es.array.reverse.js";
var _class, _class2, _class3, _class4, _SensorObservationServiceCatalogItem;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, makeObservable, override, runInAction } from "mobx";
import Mustache from "mustache";
import DeveloperError from "terriajs-cesium/Source/Core/DeveloperError";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import TerriaError from "../../../Core/TerriaError";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import loadWithXhr from "../../../Core/loadWithXhr";
import TableMixin from "../../../ModelMixins/TableMixin";
import TableAutomaticStylesStratum from "../../../Table/TableAutomaticStylesStratum";
import TableColumnType from "../../../Table/TableColumnType";
import xml2json from "../../../ThirdParty/xml2json";
import SensorObservationServiceCatalogItemTraits from "../../../Traits/TraitsClasses/SensorObservationCatalogItemTraits";
import TableChartStyleTraits, { TableChartLineStyleTraits } from "../../../Traits/TraitsClasses/Table/ChartStyleTraits";
import TablePointSizeStyleTraits from "../../../Traits/TraitsClasses/Table/PointSizeStyleTraits";
import TableStyleTraits from "../../../Traits/TraitsClasses/Table/StyleTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import StratumOrder from "../../Definition/StratumOrder";
import createStratumInstance from "../../Definition/createStratumInstance";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import defaultRequestTemplate from "./SensorObservationServiceRequestTemplate.xml";
StratumOrder.addLoadStratum(TableAutomaticStylesStratum.stratumName);
let SosAutomaticStylesStratum = (_class = class SosAutomaticStylesStratum extends TableAutomaticStylesStratum {
  constructor(catalogItem) {
    super(catalogItem);
    this.catalogItem = catalogItem;
    makeObservable(this);
  }
  duplicateLoadableStratum(newModel) {
    return new SosAutomaticStylesStratum(newModel);
  }
  get activeStyle() {
    var _this$catalogItem$pro;
    return (_this$catalogItem$pro = this.catalogItem.procedures[0]) === null || _this$catalogItem$pro === void 0 ? void 0 : _this$catalogItem$pro.identifier;
  }
  get styles() {
    return this.catalogItem.procedures.map(p => {
      return createStratumInstance(TableStyleTraits, {
        id: p.identifier,
        title: p.title,
        pointSize: createStratumInstance(TablePointSizeStyleTraits, {
          pointSizeColumn: p.identifier
        }),
        // table style is hidden by default when the table uses only 1 color (https://github.com/TerriaJS/terriajs/blob/bbe8a11ae9bf6c0eb78c52d7b5c9b260d5ddc8cf/lib/Table/TableStyle.ts#L82)
        // force hidden to false so that the frequency and procedure selector will always be shown
        // Ideally we should rewrite frequency & procedure selector using selectable dimensions and stop using styles to display them.
        hidden: false
      });
    });
  }
  get defaultChartStyle() {
    const timeColumn = this.catalogItem.tableColumns.find(column => column.type === TableColumnType.time);
    const valueColumn = this.catalogItem.tableColumns.find(column => column.type === TableColumnType.scalar);
    if (timeColumn && valueColumn) {
      return createStratumInstance(TableStyleTraits, {
        chart: createStratumInstance(TableChartStyleTraits, {
          xAxisColumn: timeColumn.name,
          lines: [createStratumInstance(TableChartLineStyleTraits, {
            yAxisColumn: valueColumn.name
          })]
        })
      });
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "activeStyle", [override], Object.getOwnPropertyDescriptor(_class.prototype, "activeStyle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "styles", [override], Object.getOwnPropertyDescriptor(_class.prototype, "styles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultChartStyle", [override], Object.getOwnPropertyDescriptor(_class.prototype, "defaultChartStyle"), _class.prototype), _class);
let GetFeatureOfInterestRequest = (_class2 = class GetFeatureOfInterestRequest {
  constructor(catalogItem, requestTemplate) {
    this.catalogItem = catalogItem;
    this.requestTemplate = requestTemplate;
    makeObservable(this);
  }
  get url() {
    return this.catalogItem.url;
  }
  get observedProperties() {
    return filterOutUndefined(this.catalogItem.observableProperties.map(p => p.identifier));
  }
  get procedures() {
    if (this.catalogItem.filterByProcedures) {
      return filterOutUndefined(this.catalogItem.procedures.map(p => p.identifier));
    }
  }
  async perform() {
    if (this.url === undefined) {
      return;
    }
    const templateContext = {
      action: "GetFeatureOfInterest",
      actionClass: "foiRetrieval",
      parameters: convertObjectToNameValueArray({
        observedProperty: this.observedProperties,
        procedure: this.procedures
      })
    };
    const response = await loadSoapBody(this.catalogItem, this.url, this.requestTemplate, templateContext);
    return response === null || response === void 0 ? void 0 : response.GetFeatureOfInterestResponse;
  }
}, _applyDecoratedDescriptor(_class2.prototype, "url", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "url"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "observedProperties", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "observedProperties"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "procedures", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "procedures"), _class2.prototype), _class2);
let GetObservationRequest = (_class3 = class GetObservationRequest {
  constructor(catalogItem, foiIdentifier) {
    this.catalogItem = catalogItem;
    this.foiIdentifier = foiIdentifier;
    makeObservable(this);
  }
  get url() {
    return this.catalogItem.url;
  }
  get requestTemplate() {
    return this.catalogItem.requestTemplate || SensorObservationServiceCatalogItem.defaultRequestTemplate;
  }
  get parameters() {
    const foiIdentifier = this.catalogItem.chartFeatureOfInterestIdentifier;
    const observableProperty = this.catalogItem.selectedObservable;
    const procedure = this.catalogItem.selectedProcedure;
    if (foiIdentifier === undefined || procedure === undefined || observableProperty === undefined) {
      return;
    }
    return convertObjectToNameValueArray({
      procedure: procedure.identifier,
      observedProperty: observableProperty.identifier,
      featureOfInterest: foiIdentifier
    });
  }

  /**
   * Return the Mustache template context "temporalFilters" for this item.
   * If a "defaultDuration" parameter (eg. 60d or 12h) exists on either
   * procedure or observableProperty, restrict to that duration from item.endDate.
   * @param item This catalog item.
   * @param procedure An element from the item.procedures array.
   * @param observableProperty An element from the item.observableProperties array.
   * @return An array of {index, startDate, endDate}, or undefined.
   */
  get temporalFilters() {
    const observableProperty = this.catalogItem.selectedObservable;
    const procedure = this.catalogItem.selectedProcedure;
    if (procedure === undefined || observableProperty === undefined) {
      return;
    }
    const defaultDuration = procedure.defaultDuration || observableProperty.defaultDuration;

    // If the item has no endDate, use the current datetime (to nearest second).
    const endDateIso8601 = this.catalogItem.endDate || JulianDate.toIso8601(JulianDate.now(), 0);
    if (defaultDuration) {
      let startDateIso8601 = addDurationToIso8601(endDateIso8601, "-" + defaultDuration);
      // This is just a string-based comparison, so timezones could make it up to 1 day wrong.
      // That much error is fine here.
      if (this.catalogItem.startDate && startDateIso8601 < this.catalogItem.startDate) {
        startDateIso8601 = this.catalogItem.startDate;
      }
      return [{
        index: 1,
        startDate: startDateIso8601,
        endDate: endDateIso8601
      }];
    } else {
      // If there is no procedure- or property-specific duration, use the item's start and end dates, if any.
      if (this.catalogItem.startDate) {
        return [{
          index: 1,
          startDate: this.catalogItem.startDate,
          endDate: endDateIso8601
        }];
      }
    }
  }
  async perform() {
    if (this.url === undefined || this.parameters === undefined) {
      return;
    }
    const templateContext = {
      action: "GetObservation",
      actionClass: "core",
      parameters: this.parameters,
      temporalFilters: this.temporalFilters
    };
    const response = await loadSoapBody(this.catalogItem, this.url, this.requestTemplate, templateContext);
    return response === null || response === void 0 ? void 0 : response.GetObservationResponse;
  }
}, _applyDecoratedDescriptor(_class3.prototype, "url", [computed], Object.getOwnPropertyDescriptor(_class3.prototype, "url"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "requestTemplate", [computed], Object.getOwnPropertyDescriptor(_class3.prototype, "requestTemplate"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "parameters", [computed], Object.getOwnPropertyDescriptor(_class3.prototype, "parameters"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "temporalFilters", [computed], Object.getOwnPropertyDescriptor(_class3.prototype, "temporalFilters"), _class3.prototype), _class3);
let SensorObservationServiceCatalogItem = (_class4 = (_SensorObservationServiceCatalogItem = class SensorObservationServiceCatalogItem extends TableMixin(CreateModel(SensorObservationServiceCatalogItemTraits)) {
  constructor(id, terria, sourceReference) {
    super(id, terria, sourceReference);
    makeObservable(this);
    this.strata.set(TableAutomaticStylesStratum.stratumName, new SosAutomaticStylesStratum(this));
  }
  get type() {
    return "sos";
  }
  async forceLoadMetadata() {}
  async forceLoadTableData() {
    if (this.showAsChart === true) {
      return this.loadChartData();
    } else {
      return this.loadFeaturesData();
    }
  }
  get cacheDuration() {
    if (isDefined(super.cacheDuration)) {
      return super.cacheDuration;
    }
    return "0d";
  }
  async loadFeaturesData() {
    const request = new GetFeatureOfInterestRequest(this, this.requestTemplate || SensorObservationServiceCatalogItem.defaultRequestTemplate);
    const response = await request.perform();
    if (response === undefined) {
      return [];
    }
    const itemName = runInAction(() => this.name || "");
    if (response.featureMember === undefined) {
      throw new TerriaError({
        sender: this,
        title: itemName,
        message: i18next.t("models.sensorObservationService.unknownFormat")
      });
    }
    let featureMembers = Array.isArray(response.featureMember) ? response.featureMember : [response.featureMember];
    const whiteList = runInAction(() => this.stationIdWhitelist);
    if (whiteList) {
      featureMembers = featureMembers.filter(m => {
        var _m$MonitoringPoint;
        return ((_m$MonitoringPoint = m.MonitoringPoint) === null || _m$MonitoringPoint === void 0 ? void 0 : _m$MonitoringPoint.identifier) && whiteList.indexOf(String(m.MonitoringPoint.identifier)) >= 0;
      });
    }
    const blackList = runInAction(() => this.stationIdBlacklist);
    if (blackList) {
      featureMembers = featureMembers.filter(m => m.MonitoringPoint && blackList.indexOf(String(m.MonitoringPoint.identifier)) < 0);
    }
    const identifierCols = ["identifier"];
    const latCols = ["lat"];
    const lonCols = ["lon"];
    const nameCols = ["name"];
    const idCols = ["id"];
    const typeCols = ["type"];
    const chartCols = ["chart"];
    featureMembers.forEach(member => {
      var _member$MonitoringPoi, _pointShape$pos, _member$MonitoringPoi2;
      const pointShape = (_member$MonitoringPoi = member.MonitoringPoint) === null || _member$MonitoringPoi === void 0 || (_member$MonitoringPoi = _member$MonitoringPoi.shape) === null || _member$MonitoringPoi === void 0 ? void 0 : _member$MonitoringPoi.Point;
      if (!pointShape) {
        throw new DeveloperError("Non-point feature not shown. You may want to implement `representAsGeoJson`. " + JSON.stringify(pointShape));
      }
      if (!member.MonitoringPoint) return;
      if (!((_pointShape$pos = pointShape.pos) !== null && _pointShape$pos !== void 0 && _pointShape$pos.split)) return;
      if (!member.MonitoringPoint.identifier) return;
      const [lat, lon] = pointShape.pos.split(" ");
      const identifier = member.MonitoringPoint.identifier;
      const name = member.MonitoringPoint.name;
      const id = member.MonitoringPoint["gml:id"];
      const type = (_member$MonitoringPoi2 = member.MonitoringPoint.type) === null || _member$MonitoringPoi2 === void 0 ? void 0 : _member$MonitoringPoi2["xlink:href"];
      const chart = createChartColumn(identifier, name);
      identifierCols.push(identifier);
      latCols.push(lat);
      lonCols.push(lon);
      nameCols.push(name || "");
      idCols.push(id || "");
      typeCols.push(type || "");
      chartCols.push(chart);
    });
    return [identifierCols, latCols, lonCols, nameCols, idCols, typeCols, chartCols];
  }
  async loadChartData() {
    const foiIdentifier = this.chartFeatureOfInterestIdentifier;
    if (foiIdentifier === undefined) {
      return [];
    }
    const request = new GetObservationRequest(this, foiIdentifier);
    const response = await request.perform();
    if (response === undefined) {
      return [];
    }
    return runInAction(() => {
      const procedure = this.selectedProcedure;
      const observableProperty = this.selectedObservable;
      const datesCol = ["date"];
      const valuesCol = ["values"];
      const observationsCol = ["observations"];
      const identifiersCol = ["identifiers"];
      const proceduresCol = [this.proceduresName];
      const observedPropertiesCol = [this.observablePropertiesName];
      const addObservationToColumns = observation => {
        var _observation$result;
        let points = observation === null || observation === void 0 || (_observation$result = observation.result) === null || _observation$result === void 0 || (_observation$result = _observation$result.MeasurementTimeseries) === null || _observation$result === void 0 ? void 0 : _observation$result.point;
        if (!points) return;
        if (!Array.isArray(points)) points = [points];
        const measurements = points.map(point => point.MeasurementTVP); // TVP = Time value pairs, I think.
        const featureIdentifier = observation.featureOfInterest["xlink:href"] || "";
        datesCol.push(...measurements.map(measurement => typeof measurement.time === "object" ? "" : measurement.time));
        valuesCol.push(...measurements.map(measurement => typeof measurement.value === "object" ? "" : measurement.value));
        identifiersCol.push(...measurements.map(_ => featureIdentifier));
        proceduresCol.push(...measurements.map(_ => procedure.identifier || ""));
        observedPropertiesCol.push(...measurements.map(_ => observableProperty.identifier || ""));
      };
      const observationData = response.observationData === undefined || Array.isArray(response.observationData) ? response.observationData : [response.observationData];
      if (!observationData) {
        return [];
      }
      const observations = observationData.map(o => o.OM_Observation);
      observations.forEach(observation => {
        if (observation) {
          addObservationToColumns(observation);
        }
      });
      runInAction(() => {
        // Set title for values column
        const valueColumn = this.addObject(CommonStrata.defaults, "columns", "values");
        valueColumn === null || valueColumn === void 0 || valueColumn.setTrait(CommonStrata.defaults, "name", "values");
        valueColumn === null || valueColumn === void 0 || valueColumn.setTrait(CommonStrata.defaults, "title", this.valueTitle);
      });
      return [datesCol, valuesCol, observationsCol, identifiersCol, proceduresCol, observedPropertiesCol];
    });
  }
  get valueTitle() {
    if (this.selectedObservable === undefined || this.selectedProcedure === undefined) {
      return;
    }
    const units = this.selectedObservable.units || this.selectedProcedure.units;
    const valueTitle = this.selectedObservable.title + " " + this.selectedProcedure.title + (units !== undefined ? " (" + units + ")" : "");
    return valueTitle;
  }
  get selectableDimensions() {
    return filterOutUndefined([
    // Filter out proceduresSelector - as it duplicates TableMixin.styleDimensions
    ...super.selectableDimensions.filter(dim => {
      var _this$proceduresSelec;
      return dim.id !== ((_this$proceduresSelec = this.proceduresSelector) === null || _this$proceduresSelec === void 0 ? void 0 : _this$proceduresSelec.id);
    }), this.proceduresSelector, this.observablesSelector]);
  }
  get proceduresSelector() {
    const proceduresSelector = super.styleDimensions;
    if (proceduresSelector === undefined) return;
    const item = this;
    return _objectSpread(_objectSpread({}, proceduresSelector), {}, {
      get name() {
        return item.proceduresName;
      }
    });
  }
  get observablesSelector() {
    if (this.mapItems.length === 0) {
      return;
    }
    const item = this;
    return {
      get id() {
        return "observables";
      },
      get name() {
        return item.observablePropertiesName;
      },
      get options() {
        return filterOutUndefined(item.observableProperties.map(p => {
          if (p.identifier && p.title) {
            return {
              id: p.identifier,
              name: p.title || p.identifier
            };
          }
        }));
      },
      get selectedId() {
        return item.selectedObservableId;
      },
      setDimensionValue(stratumId, observableId) {
        item.setTrait(stratumId, "selectedObservableId", observableId);
      }
    };
  }
  get selectedObservableId() {
    var _this$observablePrope;
    return super.selectedObservableId || ((_this$observablePrope = this.observableProperties[0]) === null || _this$observablePrope === void 0 ? void 0 : _this$observablePrope.identifier);
  }
  get selectedObservable() {
    return this.observableProperties.find(p => p.identifier === this.selectedObservableId);
  }
  get selectedProcedure() {
    return this.procedures.find(p => p.identifier === this.activeTableStyle.id);
  }
}, _defineProperty(_SensorObservationServiceCatalogItem, "type", "sos"), _defineProperty(_SensorObservationServiceCatalogItem, "defaultRequestTemplate", defaultRequestTemplate), _SensorObservationServiceCatalogItem), _applyDecoratedDescriptor(_class4.prototype, "forceLoadTableData", [action], Object.getOwnPropertyDescriptor(_class4.prototype, "forceLoadTableData"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "cacheDuration", [override], Object.getOwnPropertyDescriptor(_class4.prototype, "cacheDuration"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "loadFeaturesData", [action], Object.getOwnPropertyDescriptor(_class4.prototype, "loadFeaturesData"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "loadChartData", [action], Object.getOwnPropertyDescriptor(_class4.prototype, "loadChartData"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "valueTitle", [computed], Object.getOwnPropertyDescriptor(_class4.prototype, "valueTitle"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "selectableDimensions", [override], Object.getOwnPropertyDescriptor(_class4.prototype, "selectableDimensions"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "proceduresSelector", [computed], Object.getOwnPropertyDescriptor(_class4.prototype, "proceduresSelector"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "observablesSelector", [computed], Object.getOwnPropertyDescriptor(_class4.prototype, "observablesSelector"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "selectedObservableId", [override], Object.getOwnPropertyDescriptor(_class4.prototype, "selectedObservableId"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "selectedObservable", [computed], Object.getOwnPropertyDescriptor(_class4.prototype, "selectedObservable"), _class4.prototype), _applyDecoratedDescriptor(_class4.prototype, "selectedProcedure", [computed], Object.getOwnPropertyDescriptor(_class4.prototype, "selectedProcedure"), _class4.prototype), _class4);
export { SensorObservationServiceCatalogItem as default };
function createChartColumn(identifier, name) {
  const nameAttr = name === undefined ? "" : "name=\"".concat(name, "\"");
  // The API that provides the chart data is a SOAP API, and the download button is essentially just a link, so when you click it you get an error page.
  // can-download="false" will disable this broken download button.
  return "<sos-chart identifier=\"".concat(identifier, "\" ").concat(nameAttr, " can-download=\"false\"></sos-chart>");
}
async function loadSoapBody(item, url, requestTemplate, templateContext) {
  const requestXml = Mustache.render(requestTemplate, templateContext);
  const responseXml = await loadWithXhr({
    url: proxyCatalogItemUrl(item, url),
    responseType: "document",
    method: "POST",
    overrideMimeType: "text/xml",
    data: requestXml,
    headers: {
      "Content-Type": "application/soap+xml"
    }
  });
  if (responseXml === undefined) {
    return;
  }
  const json = xml2json(responseXml);
  if (json.Exception) {
    let errorMessage = i18next.t("models.sensorObservationService.unknownError");
    if (json.Exception.ExceptionText) {
      errorMessage = i18next.t("models.sensorObservationService.exceptionMessage", {
        exceptionText: json.Exception.ExceptionText
      });
    }
    throw new TerriaError({
      sender: item,
      title: runInAction(() => item.name || ""),
      message: errorMessage
    });
  }
  if (json.Body === undefined) {
    throw new TerriaError({
      sender: item,
      title: runInAction(() => item.name || ""),
      message: i18next.t("models.sensorObservationService.missingBody")
    });
  }
  return json.Body;
}

/**
 * Adds a period to an iso8601-formatted date.
 * Periods must be (positive or negative) numbers followed by a letter:
 * s (seconds), h (hours), d (days), y (years).
 * To avoid confusion between minutes and months, do not use m.
 * @param  dateIso8601 The date in ISO8601 format.
 * @param  durationString The duration string, in the format described.
 * @return A date string in ISO8601 format.
 */
function addDurationToIso8601(dateIso8601, durationString) {
  const duration = parseFloat(durationString);
  if (isNaN(duration) || duration === 0) {
    throw new DeveloperError("Bad duration " + durationString);
  }
  const scratchJulianDate = new JulianDate();
  let julianDate = JulianDate.fromIso8601(dateIso8601);
  const units = durationString.slice(durationString.length - 1);
  switch (units) {
    case "s":
      julianDate = JulianDate.addSeconds(julianDate, duration, scratchJulianDate);
      break;
    case "h":
      julianDate = JulianDate.addHours(julianDate, duration, scratchJulianDate);
      break;
    case "d":
      // Use addHours on 24 * numdays - on my casual reading of addDays, it needs an integer.
      julianDate = JulianDate.addHours(julianDate, duration * 24, scratchJulianDate);
      break;
    case "y":
      {
        const days = Math.round(duration * 365);
        julianDate = JulianDate.addDays(julianDate, days, scratchJulianDate);
        break;
      }
    default:
      throw new DeveloperError('Unknown duration type "' + durationString + '" (use s, h, d or y)');
  }
  return JulianDate.toIso8601(julianDate);
}

/**
 * Converts parameters {x: 'y'} into an array of {name: 'x', value: 'y'} objects.
 * Converts {x: [1, 2, ...]} into multiple objects:
 *   {name: 'x', value: 1}, {name: 'x', value: 2}, ...
 * @param parameters eg. {a: 3, b: [6, 8]}
 * @return eg. [{name: 'a', value: 3}, {name: 'b', value: 6}, {name: 'b', value: 8}]
 */
function convertObjectToNameValueArray(parameters) {
  return Object.keys(parameters).reduce((result, key) => {
    let values = parameters[key];
    if (!Array.isArray(values)) {
      values = [values];
    }
    if (values.length === 0) return result;
    return result.concat(filterOutUndefined(values.map(value => {
      return value === undefined ? undefined : {
        name: key,
        value: value
      };
    })));
  }, []);
}